<div class="consumer-flow">
  <h1 class="mt-5">{{ 'authentication.recover.title' | translate: lang }}</h1>
  <p>{{ 'authentication.recover.sub-title' | translate: lang }}</p>

  <div class="warning mt-4" [innerHTML]="'authentication.recover.errors.generic' | translate: lang" *ngIf="recoverForm.errors?.generic"></div>

  <form [formGroup]="recoverForm" (ngSubmit)="recover()" novalidate [ngClass]="recoverForm.errors?.generic ? 'mt-4' : 'mt-5'">
    <div class="mb-3">
      <broker-label [for]="'email'" [label]="'authentication.login.form.email.label' | translate: lang">
      </broker-label>
      <mat-form-field appearance="standard">
        <input
          type="email"
          matInput
          id="email"
          [formControl]="emailControl"
          [placeholder]="'authentication.login.form.email.placeholder' | translate: lang"
          (blur)="trimValue(emailControl)"
        />
      </mat-form-field>
      <mat-error *ngIf="emailControl.errors?.email">
        {{ 'authentication.login.form.email.errors.email' | translate: lang }}
      </mat-error>
    </div>

    <broker-button
      [id]="'reset'"
      [height]="'large'"
      [width]="'full-width'"
      [disabled]="!recoverForm.valid || disabled"
    >{{ 'authentication.recover.submit' | translate: lang }}</broker-button>

    <p class="mt-4">
      <a [routerLink]="['/auth/login']">{{ 'authentication.recover.login.return' | translate: lang }}</a>
    </p>
  </form>
</div>
